import type { ModalConfig } from "./types";

export const socialMediaPostModalsModalUrlConfig = {
  // Social Media Post detail modal
  "social_media_posts-detail": {
    modalId: "social_media_posts-detail",
    entityName: "social_media_posts",
    singularParam: "socialMediaPostId",
    pluralParam: "socialMediaPostsId",
    displayName: "Social Post",
  },
} as const satisfies Record<string, ModalConfig>;
